import { Injectable } from "@angular/core";
import { Select } from "@ngxs/store";
import { PermissionsService } from "@zonar-ui/auth";
import { Observable, of } from "rxjs";
import { filter, map, mergeMap } from "rxjs/operators";
import { isDefined } from "src/utils/isDefined/isDefined";
import { AppState } from "../app.state";
import { Division } from "../models/shared.model";

@Injectable({
	providedIn: "root",
})
export class AuthorizedDivisionsService {
	constructor(private perms: PermissionsService) {}

	@Select(AppState.selectDivisions) divisionsFromState$: Observable<Division[]>;

	get divisions$() {
		return this.perms.getIsZonarUser().pipe(
			mergeMap(isZonarUser => {
				if (isZonarUser) {
					return of([]);
				}

				return this.divisionsFromState$.pipe(
					filter(isDefined),
					map(divs => divs.map(d => d.divisionId)),
				);
			}),
		);
	}
}
